var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 4.1114,
    x2: 123.89,
    y1: 64,
    y2: 64
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00075733,
    stopColor: "#81d4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29b6f6"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 63.599,
    x2: 63.599,
    y1: 123.89,
    y2: 36.003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81d4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2208,
    stopColor: "#7dd3fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#72cff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#5ec8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8408,
    stopColor: "#44bff7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29b6f6"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 93.897,
    x2: 93.897,
    y1: 123.91,
    y2: 36
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#039be5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3689,
    stopColor: "#0398e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6377,
    stopColor: "#0390d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#0282c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0277bd"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 33.944,
    x2: 33.944,
    y1: 123.91,
    y2: 35.968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29b6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3305,
    stopColor: "#25b3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6457,
    stopColor: "#1aabef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9539,
    stopColor: "#079ee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#039be5"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 29.51,
    x2: 21.783,
    y1: 5.4567,
    y2: 36.366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0052615,
    stopColor: "#b3e5fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fc3f7"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0090681,
    stopColor: "#81d4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29b6f6"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 105.87,
    x2: 105.87,
    xlinkHref: "#f",
    y1: 7.0598,
    y2: 37.027
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 63.644,
    x2: 63.644,
    y1: 6.7379,
    y2: 35.715
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1f5fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#d3f0fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3e5fc"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 47.868,
    x2: 47.868,
    xlinkHref: "#f",
    y1: 4.4841,
    y2: 37.34
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 63.736,
    x2: 96,
    y1: 20.023,
    y2: 20.023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0115,
    stopColor: "#4fc3f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29b6f6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m63.85 123.84 60.1-87.8.05-.02v-.03l-27.96-31.99h-64.03l-28.01 31.93v.03l.03.07 59.42 87.45.32.44.07-.09-.22-.83z",
    fill: "#81d4fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m63.79 123.93-59.68-87.9 27.9-31.96h64.03l27.85 31.96z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m64 4-.05.07h.1z",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m63.78 123.89 23.77-87.89-47.9.05z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m87.55 36h.39l-.28-.38z",
    fill: "#81d4fa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m124 36.02-36.42-.02-23.79 87.91 60.21-87.88z",
    fill: "url(#c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m39.86 36.59-.86 1.16.86-1.16-.17-.61-35.52-.01-.06.06 59.67 87.88z",
    fill: "url(#d)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m40 36-8-31.9-28.26 31.95z",
    fill: "url(#e)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m87.74 36 8-31.9 28.26 31.95z",
    fill: "url(#g)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m39.74 36 24-31.96 23.81 31.96z",
    fill: "url(#h)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m64 4.04-24 32.01-8.26-32.05z",
    fill: "url(#i)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m63.74 4.04 24 32.01 8.26-32.05z",
    fill: "url(#j)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m94.67 7 25.53 29.2-56.42 82.41-56.02-82.42 25.61-29.19zm1.37-3h-64.03l-28.01 31.93v.03l.03.07 59.74 87.9 60.18-87.9.05-.02v-.03z",
    fill: "#424242",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.84df1173e35c58b3ca4d786078a37aa5.svg";
export { ForwardRef as ReactComponent };